"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startMeasurement = exports.hasMeasurement = exports.endMeasurement = exports.clearMeasurement = exports.clearAllMeasurements = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Non-React measurement tracker for measure-type analytics actions.
 * Provides start/end tracking with automatic duration calculation.
 *
 * This module is used by commonWebAnalytics.js to support measure-type
 * actions outside of React component context.
 */

var activeMeasurements = new Map();

/**
 * Start tracking a measurement
 * @param {string} actionId - Unique identifier for the measurement
 * @param {Object} props - Initial properties to store
 */
var startMeasurement = exports.startMeasurement = function startMeasurement(actionId) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (activeMeasurements.has(actionId)) {
    console.warn("[MeasurementTracker] Measurement already started for action: ".concat(actionId, ". Ignoring duplicate start."));
    return;
  }
  activeMeasurements.set(actionId, {
    startTime: performance.now(),
    props: _objectSpread({}, props)
  });
  console.log("[MeasurementTracker] Measurement started for action: ".concat(actionId));
};

/**
 * End a measurement and return combined properties with duration
 * @param {string} actionId - Unique identifier for the measurement
 * @param {Object} additionalProps - Additional properties to merge
 * @returns {Object|null} Combined properties with duration, or null if no measurement found
 */
var endMeasurement = exports.endMeasurement = function endMeasurement(actionId) {
  var additionalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var measurement = activeMeasurements.get(actionId);
  if (!measurement) {
    console.warn("[MeasurementTracker] No active measurement found for action: ".concat(actionId));
    return null;
  }
  var duration = performance.now() - measurement.startTime;
  var combinedProps = _objectSpread(_objectSpread(_objectSpread({}, measurement.props), additionalProps), {}, {
    duration: Math.round(duration) // Duration in milliseconds
  });
  activeMeasurements["delete"](actionId);
  return combinedProps;
};

/**
 * Clear a specific measurement without ending it
 * @param {string} actionId - Unique identifier for the measurement
 */
var clearMeasurement = exports.clearMeasurement = function clearMeasurement(actionId) {
  activeMeasurements["delete"](actionId);
};

/**
 * Clear all active measurements
 */
var clearAllMeasurements = exports.clearAllMeasurements = function clearAllMeasurements() {
  activeMeasurements.clear();
};

/**
 * Check if a measurement is active
 * @param {string} actionId - Unique identifier for the measurement
 * @returns {boolean} True if measurement is active
 */
var hasMeasurement = exports.hasMeasurement = function hasMeasurement(actionId) {
  return activeMeasurements.has(actionId);
};